import { api } from '@/lib/axios';
import type {
  ApiKeyItem,
  ApiKeyCreated,
  SyncLogEntry,
  PaginatedResponse,
} from '../types/integration.types';

// ── API Keys ────────────────────────────────────────────────────────────────

export async function fetchApiKeys(): Promise<ApiKeyItem[]> {
  const res = await api.get<{ data: ApiKeyItem[] }>('/integration/api-keys');
  return res.data.data;
}

export async function createApiKey(payload: {
  name: string;
  scopes: string[];
  expiresAt?: string;
}): Promise<ApiKeyCreated> {
  const res = await api.post<{ data: ApiKeyCreated }>('/integration/api-keys', payload);
  return res.data.data;
}

export async function toggleApiKey(id: string): Promise<ApiKeyItem> {
  const res = await api.patch<{ data: ApiKeyItem }>(`/integration/api-keys/${id}/toggle`);
  return res.data.data;
}

export async function deleteApiKey(id: string): Promise<void> {
  await api.delete(`/integration/api-keys/${id}`);
}

// ── Sync Log ────────────────────────────────────────────────────────────────

export async function fetchSyncLogs(params: {
  page?: number;
  limit?: number;
  apiKeyId?: string;
  method?: string;
  onlyErrors?: boolean;
}): Promise<PaginatedResponse<SyncLogEntry>> {
  const res = await api.get<PaginatedResponse<SyncLogEntry>>('/integration/sync-log', { params });
  return res.data;
}
